import { IContractType as ContractType } from '../../models/contract';
// import { MultiResponseType } from '../../models/multiResponseType'

export enum ActionType {
    FETCH_CONTRACTTYPES = 'FETCH_CONTRACTTYPES',
    FETCH_CONTRACTTYPES_SUCCESS = 'FETCH_CONTRACTTYPES_SUCCESS',
    FETCH_CONTRACTTYPES_FAIL = 'FETCH_CONTRACTTYPES_FAIL',
}

export interface IFetchContractTypes {
    type: ActionType.FETCH_CONTRACTTYPES;
}
export interface IFetchContractTypesSuccess {
    type: ActionType.FETCH_CONTRACTTYPES_SUCCESS;
    payload: ContractType[];
}
export interface IFetchContractTypesFail {
    type: ActionType.FETCH_CONTRACTTYPES_FAIL;
    payload: string | null;
}

export type Action =
    | IFetchContractTypes
    | IFetchContractTypesSuccess
    | IFetchContractTypesFail